

<div class="toggle-select">
  <input checked="true" type="radio" [id]="toggle.id1" [name]="toggle.name" class="opcao opcao1">
  <label class="opcao1" [for]="toggle.id1">{{ toggle.opcao1 }}</label>

  <input type="radio" [id]="toggle.id2" [name]="toggle.name" class="opcao">
  <label class="opcao2" [for]="toggle.id2">{{ toggle.opcao2 }}</label>
</div>
